import React, { useEffect, useState } from 'react';
import { adminApi, fmtCurrency, fmtDate } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { StatusPill } from '@/components/fintech/StatusPill';

export default function AdminTransactionsPage() {
  const [items, setItems] = useState([]);
  const [type, setType] = useState('all');
  useEffect(() => { adminApi.get('/admin/transactions', { params: type !== 'all' ? { tx_type: type } : {} }).then(r => setItems(r.data.items || [])); }, [type]);
  return (
    <div className="space-y-4">
      <div className="flex items-center justify-between">
        <h1 className="font-serif text-3xl text-[hsl(var(--brand-navy-2))]">Transactions</h1>
        <Select value={type} onValueChange={setType}><SelectTrigger className="w-48"><SelectValue /></SelectTrigger><SelectContent>
          <SelectItem value="all">All types</SelectItem><SelectItem value="DEPOSIT">Deposit</SelectItem><SelectItem value="WITHDRAWAL">Withdrawal</SelectItem><SelectItem value="EXCHANGE">Exchange</SelectItem>
        </SelectContent></Select>
      </div>
      <Card className="bg-white overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-[hsl(var(--secondary))]"><tr><th className="p-3 text-left">Date</th><th className="p-3 text-left">User</th><th className="p-3 text-left">Type</th><th className="p-3 text-left">Currency</th><th className="p-3 text-right">Amount</th><th className="p-3 text-left">Status</th></tr></thead>
          <tbody>
            {items.map(tx => (
              <tr key={tx.id} className="border-t">
                <td className="p-3 text-xs">{fmtDate(tx.created_at)}</td>
                <td className="p-3 text-xs">{tx.user_id.slice(0, 8)}…</td>
                <td className="p-3">{tx.type}</td>
                <td className="p-3">{tx.currency || `${tx.from_currency} → ${tx.to_currency}`}</td>
                <td className="p-3 text-right tabular-nums">{tx.type === 'EXCHANGE' ? `${fmtCurrency(tx.from_amount, tx.from_currency)} → ${fmtCurrency(tx.to_amount, tx.to_currency)}` : fmtCurrency(tx.amount, tx.currency)}</td>
                <td className="p-3"><StatusPill status={tx.status} /></td>
              </tr>
            ))}
          </tbody>
        </table>
        {items.length === 0 && <div className="p-8 text-center text-sm text-[hsl(var(--muted-foreground))]">No transactions</div>}
      </Card>
    </div>
  );
}
